import React from "react";
import Loading from "../../Loading";
import { net } from "../../../../database";
import { Button } from "@mui/material";
import StudentAvatar from "../student/components/StudentAvatar";


import ChatBoxR from "../../components/ChatBoxR";
import "./pending.css";
import { VariableSizeList as List } from "react-window";
import FormatDate from "../../components/FormatDate";
import PendingReturnDate from "../student/components/PendingReturnDate";

export default function Pending() {
  const [students, setStudents] = React.useState(undefined);

  React.useEffect(() => {
    net.get(`/students/status-min/Pending`).then((res) => setStudents(res));
  }, []);
  if (!students) return <Loading />;

  const startChat = (student) => {
    net.post(`/student/${student._id}/add-pending-chat`).then((res) => {
      setStudents((prev) => {
        let st = students.find((s) => s._id === student._id);
        st.pendingChat = res._id;
        return prev.map((s) => (s._id === student._id ? st : s));
      });
    });
  };

  const Row = ({ index, style }) => (
    <DrawStudent
      student={students[index]}
      startChat={startChat}
      key={students[index]._id}
      style={style}
    />
  );

  return (
    <div>
      <div className="pending-container-labels">
        <div style={{ width: 300 }}>Name</div>
        <div style={{ width: 100 }}>Class</div>
        <div style={{ width: 100 }}>Date pending</div>
        <div style={{ width: 150 }}>Return date</div>
        <div style={{ flexGrow: 1 }}>Notes</div>
        <div style={{ width: 400 }}>Chat</div>
      </div>
      <List
        itemCount={students.length}
        height={window.innerHeight - 180}
        itemSize={(index) => {
          if (!students[index].pendingChat) return 75;
          return 350;
        }}
      >
        {Row}
      </List>
    </div>
  );
}

function DrawStudent({ student, startChat, style }) {
  let statusChanged = student.statusHistory[student.statusHistory.length - 1];
  student = { ...statusChanged, ...student };
  const [returnDate, setReturnDate] = React.useState(
    new Date(student.returnDate)
  );
  
  return (
    <div className="pending-container" style={style}>
      <StudentAvatar student={student} />
      <div style={{ minWidth: 100, width: 100 }}>
        {student.classes.map((c) => c.name).toString()}
      </div>
      <div style={{ minWidth: 100, width: 100 }}>
        <div>
          <FormatDate value={student.startDate} />
        </div>
        <div style={{ fontSize: 11 }}>{student.changedBy.name}</div>
      </div>
      <div style={{ minWidth: 100, width: 150 }}>
        <PendingReturnDate
          value={returnDate}
          setValue={setReturnDate}
          studentId={student._id}
        />
      </div>
      <div style={{ flexGrow: 1, fontSize: 14 }}>{student.reason}</div>
      <div style={{ minWidth: 400 }}>
        {student.pendingChat ? (
          <ChatBoxR
            chatId={student.pendingChat}
            startChat={startChat}
            key={student.pendingChat}
          />
        ) : (
          <Button onClick={() => startChat(student)}>Start Chat</Button>
        )}
      </div>
    </div>
  );
}
